import React from 'react';
import {Route, Switch, Redirect} from "react-router-dom";
import {observer} from 'mobx-react-lite'
import DefaultRoute from '../../routes/DefaultRoute';
import {PageRouteProps, routes} from '../../routes/routesAdmin';
import ErrorPage from "components/error/ErrorPage";
import userStore from "common/user/store/UserStore";

function Admin() {
    return (
        <Route>
            <Switch>
                {routes.map((_item: PageRouteProps, _index: number) => {
                    return (
                        <DefaultRoute
                            exact
                            key={_index}
                            path={_item.path}
                            layout={_item.layout}
                            component={_item.component}
                        />
                    );
                })}
                {userStore.userModel == null
                    ? <Redirect to={userStore.getLoginUrl(true)}/>
                    : <Redirect from={"/admin"} exact to={"/admin/adm_main"}/>}
                <Route>
                    <ErrorPage/>
                </Route>
            </Switch>
        </Route>
    );
}

export default observer(Admin);